<template>
  <div>
    <div v-if="!isUncategozied" class="row">
      <div class="col-lg-8">
        <live-main
          :unit="unit"
          :is-preview="isPreview"
          v-on:complete-unit="completeUnit"
        />
      </div>
      <div class="col-lg-4">
        <!-- start of progress bar -->
        <assignment :unit="unit" v-if="isPreview && !isFetching" />
      </div>
    </div>
    <div v-else>
      <live-main :unit="unit" v-on:complete-unit="completeUnit" />
    </div>

    <v-dialog
      transition="dialog-top-transition"
      max-width="300"
      v-model="showDialog"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="#f9b417 darken-3" dark>Auto Next Unit</v-toolbar>
          <v-card-actions class="d-flex flex-column">
            <v-row>
              <h3>Proceeding to next unit {{ timer }}</h3>
            </v-row>
            <v-row>
              <v-col>
                <v-btn dark color="danger" :loading="isLoading" @click="cancel">
                  Cancel
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  dark
                  color="#f9b417 darken-3"
                  :loading="isLoading"
                  @click="proceedNext"
                >
                  Next
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>
<script>
import {
  filter as _filter,
  findIndex as _findIndex,
  find as _find,
  forOwn as _forOwn,
  isEmpty as _isEmpty,
  some as _some,
} from 'lodash-es';

import UnitPlaylist from '../dialog-box/UnitPlaylist.vue';
import RelatedUnits from './RelatedUnits.vue';
import UnitProgress from './Progress.vue';
import UnitMain from './Main.vue';
import LiveMain from './LiveMain.vue';
import EventBus from '@/plugins/eventBus';
import Assignment from '@/components/client-lms/UnitPage/partials/Assignment';

export default {
  name: 'PreviewUnit',

  components: {
    RelatedUnits,
    UnitPlaylist,
    UnitProgress,
    UnitMain,
    LiveMain,
    Assignment,
  },

  data: () => ({
    showDialog: false,
    unit: null,
    module_progress: 0,
    series: {
      seriesProgress: 0,
      noCompletedSeries: 0,
      units_left: 0,
    },
    isFetching: false,
    isReady: false,
    unitProgress: [
      {
        type: 'videoWatched',
        title: 'Watched the Video',
        description: 'you will be scored once you played the video',
        checked: false,
        hide: false,
      },
      {
        type: 'videoCompleted',
        title: 'Finished the Video',
        description:
          'you will be scored once you finished watching the whole video',
        checked: false,
        hide: false,
      },
      {
        type: 'quizCompleted',
        title: 'Answered the Quiz',
        description: 'you will be scored once you answered the provided quiz',
        checked: false,
        hide: false,
      },
      {
        type: 'completedUnit',
        title: 'Completed the Unit',
        description: 'you will be scored once you mark the unit as completed',
        checked: false,
        hide: true,
      },
    ],
    isAVideoTypeUnit: true,
    isUncategozied: false,
    player: null,
    timer: 5,
    timerInterval: null,
    setTimeOut: null,
    proceedingToNext: false,
    isLoading: false,
    isPreview: true,
  }),

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    module() {
      if (this.unit !== null) {
        return this.unit.module;
      }
      return null;
    },
    unitProgressRender() {
      const filtered = _filter(this.unitProgress, { hide: false });

      return _forOwn(filtered);
    },
    played: {
      get() {
        const watchedIndex = 0;
        return this.unitProgress[watchedIndex].checked;
      },
      set() {
        this.checkUnitProgress('videoWatched');
      },
    },
    unitId() {
      return this.$route.params.id;
    },
  },

  created() {
    this.isPreview = this.currentRouteName == 'PreviewUnitPage' ? true : false;
    this.fetchUnit();

    EventBus.$on('RELOAD_UNIT_PAGE', () => {
      this.fetchUnit();
      EventBus.$emit('RELOAD_RELATED_UNITS');
    });

    EventBus.$on('showAutoNextUnit', () => {
      if (this.unit.series) {
        this.showTimer();
      }
    });
  },
  methods: {
    nextUnit() {
      EventBus.$emit('nextUnit', true);
    },
    cancel() {
      clearInterval(this.timerInterval);
      clearTimeout(this.setTimeOut);
      this.showDialog = false;
      this.proceedingToNext = false;
    },
    startTimer() {
      this.proceedingToNext = true;
      this.timer = 5;
      this.setTimeOut = setTimeout(() => {
        this.next();
      }, this.timer * 1000);
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          --this.timer;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    scrollTo(refName) {
      document.getElementById(refName).scrollIntoView({
        behavior: 'smooth',
      });
    },
    initializeYoutubeAPI() {
      console.log('Intialize Youtube');

      let element = document.getElementById('unit-content');

      if (element == null) return false;

      let iframe = element.children[0];

      let src = iframe.src;

      if (src.includes('youtube')) {
        iframe.src += '?enablejsapi=1&amp;widgetid=1';
        iframe.setAttribute('id', 'player');
      }

      this.isReady = true;
      return true;
    },
    loadYoutube() {
      try {
        this.player = new YT.Player('player', {
          events: {
            onStateChange: this.onPlayerStateChange,
          },
        });
      } catch (e) {
        this.loadYoutube();
      }
    },
    onPlayerStateChange(event) {
      let status = event.target.getPlayerState();

      // -1 – unstarted
      // 0 – ended
      // 1 – playing
      // 2 – paused
      // 3 – buffering
      // 5 – video cued
      if (status == 1) {
        this.processPlayedVideo(this.unit.id);
      } else if (status == 0) {
        if (this.unit.quiz_id) {
          let goto = this.unit.is_quiz_done
            ? 'quiz-completed'
            : 'quiz-question';

          if (this.unit.is_quiz_done) {
            if (this.unit.series) {
              this.showTimer();
            }
          } else {
            this.scrollTo(goto);
          }
        } else {
          EventBus.$emit('finishedVideo', true);
          if (this.unit.series) {
            this.showTimer();
          }
        }

        this.markUnitAsFinishedTheVideo(this.unit.id);
        event.target.stopVideo();
      }
    },
    fetchUnit() {
      this.isFetching = true;
      this.$parent.unitPageLoading = true;
      this.axios
        .get('/client/lms/unit/' + this.unitId, {
          params: {
            type: 'module',
          },
        })
        .then(({ data }) => {
          this.isUncategozied = data.is_uncategorized;
          this.series.seriesProgress = data.series_progress;
          this.series.noCompletedSeries = data.no_completed_series;
          this.module_progress = data.module_progress;
          this.series.units_left = data.units_left;
          this.unit = data.unit;
          this.$store.commit('markAsCompleted/setCurrentUnitId', data.unit.id);
          this.$store.commit('clientUnit/setSelectedItem', data);
          this.isFetching = false;
          this.$parent.unitPageLoading = false;
          if (data.unit.quiz_id) {
            this.isQuizAlreadyAnswered();
          } else {
            this.$store.commit('clientUnit/setQuizResult', null);
            this.hideUnitProgress('quizCompleted');
          }

          if (
            !(
              data.unit.content.includes('vimeo') ||
              data.unit.content.includes('youtube')
            )
          ) {
            this.isAVideoTypeUnit = false;
            this.hideVideoUnitProgressTasks();
          }

          this.callIntro();
        })
        .catch(() => {
          this.$router.push({
            name: 'PageNotFound',
          });
        })
        .finally(() => {
          this.loadVimeoPlayerSettings(this.unit.id);
          if (this.unit.is_uploading) {
            if (this.checkTranscodeStatus(this.unit.id)) {
              this.fetchUnit();
            }
          }
        });
    },

    proceedNext() {
      this.proceedingToNext = true;
      this.isLoading = true;
      clearTimeout(this.setTimeOut);
      this.next();
    },

    next() {
      if (this.proceedingToNext) {
        if (this.$route.params.playlistId) {
          return this.navigateAroundPlaylist('next');
        }
        return this.axios
          .post('client/lms/related-units', {
            unitId: this.unit.id,
            type: 'single',
            action: 'next',
          })
          .then(({ data }) => {
            if (data !== null) {
              return this.$router.push({
                name: 'UnitPage',
                params: {
                  id: data,
                },
              });
            }

            return this.$notify(
              'warning',
              'This is the last unit in the list.'
            );
          });
      }
    },
    previous() {
      const { type } = this.$store.state.relatedUnits;
      if (type === 'playlist') {
        return this.navigateAroundPlaylist('back');
      }
      return this.axios
        .post('client/lms/related-units', {
          unitId: this.unit.id,
          type: 'single',
          action: 'prev',
        })
        .then(({ data }) => {
          if (data !== null) {
            return this.$router.push({
              name: 'UnitPage',
              params: {
                id: data,
              },
            });
          }

          return this.$notify('warning', 'This is the first unit in the list.');
        });
    },
    navigateAroundPlaylist(type) {
      if (type === 'back') {
        const prevId = this.$store.getters[
          'relatedUnits/getPrevUnitInPlaylist'
        ](this.unit.id);

        if (Number.isInteger(prevId)) {
          return this.$router.push({
            name: 'PlaylistUnitPage',
            params: {
              id: prevId,
              playlistId: this.$route.params.playlistId,
            },
          });
        }

        return this.$notify('warning', 'This is the first unit in the list.');
      }

      const nextId = this.$store.getters['relatedUnits/getNextUnitInPlaylist'](
        this.unit.id
      );

      if (Number.isInteger(nextId)) {
        return this.$router.push({
          name: 'PlaylistUnitPage',
          params: {
            id: nextId,
            playlistId: this.$route.params.playlistId,
          },
        });
      }

      return this.$notify('warning', 'This is the last unit in the list.');
    },

    isQuizAlreadyAnswered() {
      this.axios
        .get(`/client/lms/quiz/${this.unit.quiz.id}`, {
          params: {
            unit_id: this.unit.id,
          },
        })
        .then(({ data }) => {
          this.$store.commit('clientUnit/setQuizResult', data.data);

          if (data.data) {
            this.checkUnitProgress('quizCompleted');
          }
        })
        .catch((error) => {
          this.$store.commit('clientUnit/setQuizResult', null);
        });
    },

    hideUnitProgress(type) {
      const index = _findIndex(this.unitProgress, { type });

      this.unitProgress[index].hide = true;
    },

    hideVideoUnitProgressTasks() {
      const tasks = _forOwn(this.unitProgress);
      const quizCompletedTask = _find(this.unitProgress, {
        type: 'quizCompleted',
      });

      tasks.forEach((item, index) => {
        let value = item.type !== 'completedUnit';

        // if quiz exist in this unit, skip hide of quiz
        if (item.type === 'quizCompleted' && !item.hide) {
          value = false;
        }

        // if item is a "completedUnit" and
        // quiz exist in this unit, hide this item
        if (item.type === 'completedUnit' && !quizCompletedTask.hide) {
          value = true;
        }

        this.unitProgress[index].hide = value;
      });
    },

    loadVimeoPlayerSettings(unitId = null) {
      if (this.unit.content.search('vimeo') > 0) {
        setTimeout(() => {
          const player = document.querySelector(
            'iframe#unit-video-' + this.unit.id
          );
          this.vPlayer = new Vimeo.Player(player);
          this.vPlayer.on('play', () => {
            this.processPlayedVideo(unitId);
          });

          this.vPlayer.on('ended', () => {
            if (this.unit.quiz_id) {
              let goto = this.unit.is_quiz_done
                ? 'quiz-completed'
                : 'quiz-question';

              if (this.unit.is_quiz_done) {
                this.showTimer();
              } else {
                this.scrollTo(goto);
              }
            } else {
              EventBus.$emit('finishedVideo', true);

              this.showTimer();
            }

            this.markUnitAsFinishedTheVideo(this.unit.id);
          });
        }, 1000);
      }
    },

    processPlayedVideo(unitId) {
      const { type } = this.$store.state.relatedUnits;

      if (this.played) {
        return;
      }

      this.$http
        .post('/mark-user-unit-video-played', {
          unit_id: unitId,
          type,
          playlistId: this.$store.state.markAsCompleted.playlist_id,
        })
        .then(() => {
          const completedIndex = 0;

          this.played = true;
          this.unitProgress[completedIndex].checked = true;
        });
    },

    markUnitAsFinishedTheVideo(unitId) {
      const { type } = this.$store.state.relatedUnits;
      this.$http
        .post('/client/lms/unit/finished/watching', {
          unit_id: unitId,
          type,
          playlistId: this.$store.state.markAsCompleted.playlist_id,
        })
        .then((data) => {
          this.unit.is_finished_watching = true;
          this.series.units_left = data.data.units_left;
          this.series.seriesProgress = data.data.series_progress;
          this.series.noCompletedSeries = data.data.no_completed_series;
          this.checkUnitProgress('videoCompleted');
        });
    },

    callIntro() {
      let _this = this;
      setTimeout(function () {
        _this.$_introUnitPage();
      }, 2000);
    },

    checkUnitProgress(type) {
      const index = _findIndex(this.unitProgress, { type });

      this.unitProgress[index].checked = true;
    },

    completeUnit() {
      this.checkUnitProgress('videoWatched');
      this.checkUnitProgress('videoCompleted');
      this.checkUnitProgress('quizCompleted');
      this.checkUnitProgress('completedUnit');

      if (this.unit.series) {
        this.showTimer();
      }
    },
    showTimer() {
      this.showDialog = true;
      this.startTimer();
    },
  },
  updated() {
    if (!this.isReady) {
      if (this.initializeYoutubeAPI()) {
        this.loadYoutube();
      }
    }
  },
};
</script>
